import { Button, Container, Link, Typography } from "@mui/material";
import * as React from "react";
import Logo from "../../../assets/logo/1800AccountantLogo.svg";
import Recycle from "../../../assets/icons-svg/recycle.svg";

interface BoundaryState {
  hasError: boolean;
}
interface BoundaryProps {
  children: JSX.Element;
}
class ErrorBoundary extends React.Component<BoundaryProps, BoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
    this.reload = this.reload.bind(this);
  }
  static getDerivedStateFromError(error: Error): BoundaryState {
    // updated to true for fallback UI.
    return { hasError: true };
  }
  reload() {
    window.location.reload();
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    //catch error and log here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app">
          <Container maxWidth={false} className="error-boundary">
           <div>           
              <img src={Logo} alt="1800-Accountant logo" />
              <div className="error-boundary__error-text">
                <img src={Recycle} alt={`error`} />
                <Typography variant="h3">Something went wrong</Typography>
              </div>
                <Typography variant="h6">
                  Sorry for the inconvenience, please try to reload the page
                </Typography>
                  <Button onClick={this.reload}>Refresh the page</Button>
              <div>
                Questions? Call us at{" "}
                <Link className="" href="tel:1-800-222-6868">
                  1-800-222-6868
                </Link>
              </div>
              </div>       
          </Container>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
